import LegalPolicy from "../LegalPolicy.tsx";

export default function PrivacyPolicyPage() {
	return <LegalPolicy id="a8cf8512-0ad0-4152-93ff-c427c280dd0d" />;
}
